document.addEventListener("DOMContentLoaded", function () {
        var wishlistHTML = wishlistPrint();
        if (wishlistHTML !== "") {
          document.querySelectorAll('#wishlist_content').forEach(e => {
            e.innerHTML = `<div class="display-wishlist-pro">${wishlistHTML}</div>`;
          });
        }

      document.addEventListener('click', function(event) {
          if (event.target.matches('.wishlist-remove-products')) {
            let productIdToRemove = event.target.getAttribute("data-wishlist-product-id")
            document.querySelector(`[data-product-card="${productIdToRemove}"]`).remove();
            removeFromWishlist(productIdToRemove)
            updateWishlistCount()
          }
        });

     function removeFromProductId(productIdToRemove){
        // Get the wishlist from localStorage
        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || {
            wishlistProductId: [],
            wishlistVariantId: []
        };
        
        // The product ID to remove
        
        // Check if wishlistProductId exists and filter out the unwanted ID
        if (wishlist.wishlistProductId) {
            wishlist.wishlistProductId = wishlist.wishlistProductId.filter(id => id !== productIdToRemove);
        }
        
        // Save the updated wishlist back to localStorage
        localStorage.setItem("wishlist", JSON.stringify(wishlist));
        
        console.log("Updated wishlist:", wishlist);
      }

      function wishlistPrint(){
        var productIds = "";
        var productsToHtml = ""
        
        const wishlistProducts = JSON.parse(localStorage.getItem('wishlist')) || [];
        wishlistProducts.wishlistProducts.forEach(e => {
            if(e.price != null){
              var price = '$' + e.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }else{
              price = "Price"
            } 
            // console.log(e)
             productsToHtml += `
             
                <div class="card wishlist-product-item" data-product-card="${e.product_id}">
                 <span class="wishlist-remove-products"  data-wishlist-product-id="${e.product_id}">
                        <svg width="25" height="40" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="5.25781" y="7.22656" width="1.7" height="17" transform="rotate(-45 5.25781 7.22656)" fill="#092B2F"></rect>
                        <rect x="6.75781" y="19.2461" width="1.7" height="17" transform="rotate(-135 6.75781 19.2461)" fill="#092B2F"></rect>
                      </svg>
                      </span>
                <a href="${e.link}">
                    <img src="${e.product_image}" class="card-img-top" alt="Product_image">
                    <div class="card-body">
                      <h5 class="card-title">${e.product_name}</h5>
                       ${price}
                    <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="45763849683162">
                       <input type="hidden" name="quantity" value="1">
                                                 
                      <div class="product-form__buttons">
                                            <button type="submit" name="add" class="product-form__submit button button--full-width button--primary">
                                              <span>Add to cart
                                          </span>
                                            
                        </button>
                                          
                                          </div><input type="hidden" name="id" value="${e.variant_id}">
                      </form>
                     
                     
                    </div>  
                    </a>
                  </div>              
                    
              `;
          
        })
        if(productsToHtml == ""){
          productsToHtml =
            `<div stlye="text-align: center;" style="
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 15px;
                margin: 50px;
            ">
                <svg data-name="Layer 1" id="Layer_1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="
                    width: 70px;
                    opacity: 0.5;
                ">
                  <title></title>
                  <path d="M50,5A45,45,0,1,0,95,50,45.00058,45.00058,0,0,0,50,5Zm0,88A43.00035,43.00035,0,1,1,80.40552,80.40546,42.86117,42.86117,0,0,1,50,93Z"></path>
                  <path d="M72.933,41.70825A11.99014,11.99014,0,0,0,61.151,31.00006L61.1283,31a11.73514,11.73514,0,0,0-6.573,2.16217,17.35239,17.35239,0,0,0-3.97949,3.8949c-.21705.2901-.40674.56152-.57581.813-.16907-.25153-.35883-.523-.57587-.813a17.35077,17.35077,0,0,0-3.97943-3.8949A11.73514,11.73514,0,0,0,38.8717,31l-.0227.00006A11.99014,11.99014,0,0,0,27.067,41.70825l-.00336.03955c-.032.507-.06274,1.73865-.06366,1.95679.00726,3.2464,1.3924,6.5719,3.40112,9.79047A66.93473,66.93473,0,0,0,41.77539,66.46167c3.86487,3.52625,7.10657,5.95538,7.63043,6.34265a1.00217,1.00217,0,0,0,1.18836,0A105.02876,105.02876,0,0,0,62.21954,62.60339a56.55,56.55,0,0,0,7.37934-9.10833C71.6076,50.27643,72.99268,46.951,73,43.70459c-.00092-.21814-.03162-1.44977-.06366-1.95679Zm-16.05639,23.276c-3.03931,2.7735-5.69342,4.86042-6.87647,5.76361A104.07454,104.07454,0,0,1,39.2132,61.208a54.61843,54.61843,0,0,1-7.1167-8.77387c-1.90662-3.03821-3.10376-6.0758-3.0965-8.72949-.00092-.11279.03156-1.38287.05786-1.79907a9.98979,9.98979,0,0,1,9.80444-8.905,9.73076,9.73076,0,0,1,5.4502,1.81036,15.37578,15.37578,0,0,1,3.51038,3.44446,17.13237,17.13237,0,0,1,.97253,1.444c.10773.17981.18781.32233.23975.41754l.0567.106.01245.024.00171.00342a1.00006,1.00006,0,0,0,1.788,0l.00171-.00342a15.17486,15.17486,0,0,1,1.28137-1.99158,15.37739,15.37739,0,0,1,3.51044-3.44446,9.73076,9.73076,0,0,1,5.4502-1.81036,9.98979,9.98979,0,0,1,9.80444,8.905c.0263.4162.05878,1.68628.05786,1.79907.00726,2.65369-1.18988,5.69128-3.0965,8.72949A65.07486,65.07486,0,0,1,56.87659,64.98425Z"></path>
                </svg>
                <h1>Your Wishtlist is empty</h1>
            </div>`
          }
        return productsToHtml;
      }

      function removeFromWishlist(productIdToRemove) {
        // Retrieve wishlist from localStorage
        console.log(productIdToRemove)
        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || {
            wishlistProducts: [],
            wishlistVariantId: []
        };
    
        if (wishlist.wishlistProducts && wishlist.wishlistProducts.length > 0) {
            // Create a new array excluding the product to be removed
            let updatedWishlistProducts = [];
            
            wishlist.wishlistProducts.forEach((product) => {
                if (product.product_id !== productIdToRemove) {
                    updatedWishlistProducts.push(product);
                }
            });
    
            // Assign updated array to wishlist
            wishlist.wishlistProducts = updatedWishlistProducts;
        }
    
        // Save the updated wishlist back to localStorage
        localStorage.setItem("wishlist", JSON.stringify(wishlist));
    
        console.log("Updated wishlist after removal:", wishlist);
    }
  });
